import { render } from "./AllocationDonut.vue?vue&type=template&id=52f595ce&scoped=true"
import script from "./AllocationDonut.vue?vue&type=script&lang=js"
export * from "./AllocationDonut.vue?vue&type=script&lang=js"

import "./AllocationDonut.vue?vue&type=style&index=0&id=52f595ce&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52f595ce"]])

export default __exports__